export default function Footer() {
  return (
    <footer id="about" className="bg-[#050810] border-t border-navy-border py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/082ecbf3b95a41c4fe2e0b7873d9af01/65542f73881bfda9fc8d299d14161080.png" 
                alt="IAN MEDIA" 
                className="h-8 md:h-10 w-auto"
              />
              <span className="text-lg md:text-xl font-bold text-white font-display">IAN MEDIA</span>
            </div>
            <p className="text-white/55 mb-5 md:mb-6 leading-[1.9] text-sm md:text-[0.95rem] max-w-xs">
              데이터 기반 퍼포먼스 마케팅으로
              <br />
              비즈니스 성장을 설계합니다.
              <br className="md:hidden" />
              <span className="text-white/35 text-xs md:text-sm block mt-1">350개 이상의 브랜드가 신뢰하는 프리미엄 에이전시</span>
            </p>

            {/* Business Info */}
            <div className="mb-5 md:mb-6 space-y-1">
              {[
                { label: '상호', value: '주식회사 이안미디어' },
                { label: '사업자등록번호', value: '645-81-03740' },
                { label: '대표자', value: '고광온' },
              ].map(({ label, value }) => (
                <div key={label} className="flex items-center gap-2 text-xs text-white/35">
                  <span className="text-white/20 whitespace-nowrap">{label}</span>
                  <span className="w-px h-3 bg-white/10 flex-shrink-0" />
                  <span className="text-white/45">{value}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center space-x-3 md:space-x-4">
              <a href="#" rel="nofollow" className="w-9 h-9 md:w-10 md:h-10 bg-navy-card border border-navy-border rounded-lg flex items-center justify-center text-white/60 hover:text-neon hover:border-neon/30 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 md:w-10 md:h-10 bg-navy-card border border-navy-border rounded-lg flex items-center justify-center text-white/60 hover:text-neon hover:border-neon/30 transition-colors cursor-pointer">
                <i className="ri-kakao-talk-fill text-base md:text-lg"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 md:w-10 md:h-10 bg-navy-card border border-navy-border rounded-lg flex items-center justify-center text-white/60 hover:text-neon hover:border-neon/30 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-base md:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services + Contact side by side on mobile */}
          <div className="grid grid-cols-2 gap-6 md:contents">
            <div>
              <h4 className="text-white font-bold mb-3 md:mb-4 text-sm md:text-base">
                <a href="#services" className="hover:text-neon transition-colors">서비스</a>
              </h4>
              <ul className="space-y-2 md:space-y-3 text-white/60 text-xs md:text-sm">
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">검색 광고 (네이버·구글)</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">SNS 광고 (메타·인스타)</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">퍼포먼스 마케팅</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">브랜딩</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-bold mb-3 md:mb-4 text-sm md:text-base">
                <a href="#contact" className="hover:text-neon transition-colors">문의</a>
              </h4>
              <ul className="space-y-2 md:space-y-3 text-white/60 text-xs md:text-sm">
                <li className="flex items-center space-x-2">
                  <i className="ri-mail-line text-neon flex-shrink-0"></i>
                  <span className="break-all">ianmedia01@naver.com</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-time-line text-neon flex-shrink-0"></i>
                  <span>평일 09:30 ~ 18:30</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-navy-border pt-6 md:pt-8 flex flex-col items-center gap-3 md:flex-row md:justify-between md:gap-4">
          <p className="text-white/40 text-xs md:text-sm text-center md:text-left">
            © 2026 IAN MEDIA (이안미디어). All rights reserved.
          </p>
          <div className="flex items-center space-x-4 md:space-x-6 text-white/40 text-xs md:text-sm">
            <a href="#" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">개인정보처리방침</a>
            <a href="#" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">이용약관</a>
          </div>
        </div>
      </div>
    </footer>
  );
}